<template>
  <a
    v-if="uri"
    class="rich-suggestion"
    :class="alignment"
    target="_self"
    rel="noopener noreferrer"
    :href="uri">
    {{title}}
  </a>
  <button v-else class="rich-suggestion" :class="alignment" @click="$emit('select')">{{title}}</button>
</template>

<script>
export default {
  name: 'RichSuggestion',
  emits: ['select'],
  props: {
    uri: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    alignment: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/style/mixins'

body.geneartgenes .rich-suggestion
  width: auto
  float: none !important

.rich-suggestion
  @include reset
  display: inline-block
  padding: 8px 12px
  border-radius: 32px
  border: var(--border)
  color: var(--text-primary)
  cursor: pointer
  margin-bottom: 5px
  font-size: 12px
  line-height: 1rem

  &.row
    display: inline-block
    margin-right: 6px
    width: auto
    padding: 8px 14px

  &.column
    display: block

  &[href]
    color: var(--accent)
    text-decoration: none
    border: var(--border)
</style>
